import * as Yup from "yup";

export * from "./base-forms/validators.js";

export const firstname = Yup.string().trim();
export const lastname = Yup.string().trim();
